import Image from "next/image";
import { AppStoreButtonContainer } from "styles";

export default function AppStoreButton() {
	return (
		<AppStoreButtonContainer>
			<a
				href="https://apps.apple.com/us/app/wishbox-finance/id1517031842"
				title="Download on the App Store"
				target="_blank"
				rel="noopener noreferrer"
			>
				<Image
					unoptimized
					src="/assets/app_store_badge.svg"
					alt="Download on the App Store"
					style={{
						position: "relative",
						top: -55,
						display: "block",
						width: 160,
						height: "auto",
						padding: 0,
						margin: 0,
						border: 0
					}}
					width={160}
					height={48}
				/>
			</a>
		</AppStoreButtonContainer>
	);
}
